import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import styled from "styled-components";
import Axios from "axios";
import CustomInput from "./CustomInput";
import CustomSelect from "./CustomSelect";
import NoResultCas from "../helpers/NoResultCas";
import { Token } from "../tmp/Token";
import moment from "moment";
import ContentLoader from "react-content-loader";
import img from "../images/sprite_3.png";
import ApiCall from "../services/ApiCall";
import GalleryDAO from "../DAO/GalleryDAO";
import AccountDAO from "../DAO/AccountDAO";
import UserDAO from "../DAO/UserDAO";
import ProductDAO from "../DAO/ProductDAO";
import CommonDAO from "../DAO/CommonDAO";
import CustomDatePicker from "../components/CustomDatePicker";
import { RoutesPath } from "../values/RoutesPath";
import DataLoadingError from "../components/DataLoadingError";
import SearchSelect from "../helpers/SearchSelect";
import { DatePicker } from "../components/CustomDatePicker";
import { notify } from "../helpers/FlashMessage";
import { acl } from "../services/acl";
import { MessagesText } from "../values/MessagesText";

class GalleryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageNumber: 1,
            data: null,
            totalItems: 0,
            account_type: "",
            account_id: "",
            first_name: "",
            last_name: "",
            phone: "",
            category: "",
            accounts: [],
            name: "",
            date: "",
            products: [],
            product_id: [],

            user_id: [],
            users: [],
            download_at: null,
            download_by: "",

            name_operator: "like",
            date_operator: "like",
            account_id_operator: "is",
            product_id_operator: "is",
            download_by_operator: "is",
            download_at_operator: "like",

            search: false,
            advancedSearch: false,

            is_loaded: false,
            error: {
                is: false,
                message: "",
            },
            selected_product: {},
            selected_account: {},
            selected_user: {},

            orderBy: 0,
            key: "",
        };
    }
    componentDidMount() {
        this.setState({ is_loaded: false }, () => this.getAll());
        this.getAccounts();
        this.getProducts();
        this.getUsers();
    }
    async getAll() {
        const { disabledData } = this.props;
        try {
            this.setLoadingError({ is: false, message: "" });

            const { orderBy, key, search, advancedSearch, pageNumber, account_id, product_id, user_id, name, download_at, date, download_at_operator, download_by_operator, product_id_operator, account_id_operator, date_operator, name_operator } = this.state;
            let data = GalleryDAO.getSearchDataTable({ search, advancedSearch, pageNumber, account_id, product_id, user_id, name, download_at, date, download_at_operator, download_by_operator, product_id_operator, account_id_operator, date_operator, name_operator });
            data["disabled"] = {
                value: disabledData,
                op: "is",
            };
            if (orderBy !== 0 && key.length !== 0) {
                data["orderby"] = {
                    col: key,
                    dir: orderBy === 1 ? "ASC" : "DESC",
                };
            } else {
                data["orderby"] = {
                    col: "id",
                    dir: "DESC",
                };
            }
            if (data) {
                const response = await GalleryDAO.getALLPhotos(pageNumber, {}, data);
                this.setState({ is_loaded: true, data: response.data, totalItems: response.data.total });
            }
        } catch (error) {
            this.setState({ is_loaded: true });
            this.setLoadingError({ is: true, message: error.message });
        }
    }
    setLoadingError(error) {
        this.setState((prevState) => ({
            ...prevState,
            error: {
                ...prevState.error,
                is: error.is,
                message: error.message,
            },
        }));
    }
    async getAccounts() {
        try {
            const data = {};
            const response = await AccountDAO.getALLAccounts(1, {}, data);
            this.setState({ accounts: response.data.comptes });
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }

    async getProducts() {
        try {
            const response = await ProductDAO.getALLProducts(1, {});
            this.setState({ products: response.data.ressources });
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }

    async getUsers() {
        try {
            const data = {
                pagination: {
                    value: "OFF",
                },
            };
            const response = await UserDAO.getALLUsers(1, {}, data);
            this.setState({ users: response.data.utilisateurs });
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }

    sort(property) {
        const sortedData = CommonDAO.sortData(this.state.data.photos, property);
        const data = this.state.data;
        data.photos = [...sortedData];
        this.setState({ data });
    }

    reverse(property) {
        const sortedData = CommonDAO.reverseData(this.state.data.photos, property);
        const data = this.state.data;
        data.photos = [...sortedData];
        this.setState({ data });
    }

    handleKeyDown(e) {
        if (e.key === "Enter") {
            this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll());
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps.disabledData !== this.props.disabledData) {
            this.getAll();
        }
    }
    resetSearch() {
        this.setState(
            {
                is_loaded: false,
                account_type: "",
                account_id: "",
                first_name: "",
                last_name: "",
                phone: "",
                category: "",
                name: "",
                date: null,
                product_id: [],

                user_id: [],
                download_at: null,
                download_by: "",

                name_operator: "like",
                date_operator: "like",
                account_id_operator: "is",
                product_id_operator: "is",
                download_by_operator: "is",
                download_at_operator: "like",

                selected_product: {},
                selected_account: {},
                selected_user: {},
            },
            () => this.getAll()
        );
    }
    getOrderBy() {
        const { orderBy } = this.state;
        switch (orderBy) {
            case 0:
                return 1;
                break;
            case 1:
                return -1;
                break;
            case -1:
                return 1;
                break;
            default:
                return 0;
                break;
        }
    }
    async delete(id) {
        try {
            var delete_item = window.confirm("Etes-vous sûr de vouloir faire effectuer cette action, les modifications seront définitives !");
            if (delete_item) {
                const data = {
                    disabled: 1,
                };
                const response = await GalleryDAO.deletePhoto(id, {}, data);

                if (response.data && response.data.status === "ok") {
                    notify({ msg: MessagesText.gallery.delete, type: "success" });
                    this.getAll();
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    async restore(id) {
        try {
            var delete_item = window.confirm("Etes-vous sûr de vouloir faire effectuer cette action, les modifications seront définitives !");
            if (delete_item) {
                const data = {
                    disabled: 0,
                };
                const response = await GalleryDAO.deletePhoto(id, {}, data);

                if (response.data && response.data.status === "ok") {
                    notify({ msg: MessagesText.gallery.restore, type: "success" });
                    this.getAll();
                } else {
                    notify({ msg: response.data.msg, type: "danger" });
                }
            }
        } catch (error) {
            notify({ msg: error.message, type: "danger" });
        }
    }
    render() {
        const {
            error,
            is_loaded,
            advancedSearch,
            download_at_operator,
            download_by_operator,
            product_id_operator,
            account_id_operator,
            date_operator,
            name_operator,
            date,
            data,
            pageNumber,
            totalItems,
            search,
            account_type,
            first_name,
            last_name,
            phone,
            account_id,
            category,
            accounts,
            products,
            product_id,
            users,
            user_id,
            name,
            download_at,
            key,
            orderBy,
        } = this.state;
        const { disabledData } = this.props;
        return (
            <Bloc className="Bloc">
                <div className="bloc_header">
                    <h2>Liste des photos</h2>
                    <div className="bloc_header_btns">
                        <a onClick={() => this.setState({ advancedSearch: false, search: search ? false : true })} className="sprite-bloc-search" />
                        <a onClick={() => this.resetSearch()} className="sprite-bloc-reload"></a>
                        <a onClick={() => this.setState({ search: false, advancedSearch: advancedSearch ? false : true })} href="#" className="sprite-bloc-star"></a>
                    </div>
                </div>
                <div className="bloc_content table_wrraper">
                    <table className="table processableTable" id="26555_e2d99ecca39dab4b0c717798144e1d8f" data-ajax_url="/invoices" data-object_table="invoices">
                        <thead>
                            {advancedSearch && (
                                <SearchTr className="table_th_orderable">
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ name_operator: value.target.value });
                                                }}
                                                selectedValue={name_operator}
                                                label="Nom"
                                            >
                                                <option value="like" defaultValue>
                                                    contient
                                                </option>
                                                <option value="not_like">ne contient pas</option>
                                                <option value="starts_with">commence par</option>
                                                <option value="end_by">se termine par</option>
                                                <option value="is">est</option>
                                                <option value="is_not">n'est pas</option>
                                                <option value="null">est vide</option>
                                                <option value="not_null">n'est pas vide</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ date_operator: value.target.value });
                                                }}
                                                selectedValue={date_operator}
                                                label="Date"
                                            >
                                                <option value="like" defaultValue>
                                                    contient
                                                </option>
                                                <option value="not_like">ne contient pas</option>
                                                <option value="starts_with">commence par</option>
                                                <option value="end_by">se termine par</option>
                                                <option value="is">est</option>
                                                <option value="is_not">n'est pas</option>
                                                <option value="null">est vide</option>
                                                <option value="not_null">n'est pas vide</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ account_id_operator: value.target.value });
                                                }}
                                                selectedValue={account_id_operator}
                                                label="Compte"
                                            >
                                                <option value="is" defaultValue>
                                                    est
                                                </option>
                                                <option value="is_not">n'est pas</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ product_id_operator: value.target.value });
                                                }}
                                                selectedValue={product_id_operator}
                                                label="Produit"
                                            >
                                                <option value="is" defaultValue>
                                                    est
                                                </option>
                                                <option value="is_not">n'est pas</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ download_at_operator: value.target.value });
                                                }}
                                                selectedValue={download_at_operator}
                                                label="Téléchargé le"
                                            >
                                                <option value="is" defaultValue>
                                                    est
                                                </option>
                                                <option value="is_not">n'est pas</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomSelect
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                error={false}
                                                onChange={(value) => {
                                                    this.setState({ download_by_operator: value.target.value });
                                                }}
                                                selectedValue={download_by_operator}
                                                label="Téléchargé par"
                                            >
                                                <option value="is" defaultValue>
                                                    est
                                                </option>
                                                <option value="is_not">n'est pas</option>
                                            </CustomSelect>
                                        </Search_input_container>
                                    </Th>

                                    <Th backgroundColor="#fff">
                                        <Search_btn onClick={() => this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll())}>
                                            <Search_btn_icon aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path
                                                    fill="#fff"
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                ></path>
                                            </Search_btn_icon>
                                        </Search_btn>
                                    </Th>
                                </SearchTr>
                            )}

                            {/* <tr className="table_th_orderable">
                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <CustomInput
                                            onKeyDown={this.handleKeyDown.bind(this)}
                                            onChange={(value) => {
                                                this.setState({ name: value.target.value });
                                            }}
                                            label="Nom"
                                        ></CustomInput>
                                        <Search_icon>
                                            <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path
                                                    fill="currentColor"
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                ></path>
                                            </Svg>
                                        </Search_icon>
                                    </Search_input_container>
                                </Th>
                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <CustomInput
                                            onKeyDown={this.handleKeyDown.bind(this)}
                                            onChange={(value) => {
                                                this.setState({ date: value.target.value });
                                            }}
                                            label="Date"
                                        ></CustomInput>
                                        <Search_icon>
                                            <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path
                                                    fill="currentColor"
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                ></path>
                                            </Svg>
                                        </Search_icon>
                                    </Search_input_container>
                                </Th>
                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <SearchSelect
                                            fetchedUrl="/api/comptes"
                                            HTTPMethod="post"
                                            receivedObject="comptes"
                                            optionLabelProperty="libelle"
                                            optionValueProperty="id"
                                            value={this.state.selected_account}
                                            placeholder="Compte"
                                            onChange={(e) => {
                                                this.setState({ selected_account: e, account_id: e.value });
                                            }}
                                        />
                                    </Search_input_container>
                                </Th>

                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <SearchSelect
                                            fetchedUrl="/api/produits"
                                            HTTPMethod="get"
                                            receivedObject="ressources"
                                            optionLabelProperty="nom"
                                            optionValueProperty="id"
                                            value={this.state.selected_product}
                                            placeholder="Produit"
                                            onChange={(e) => {
                                                this.setState({ selected_product: e, product_id: e.value });
                                            }}
                                        />
                                    </Search_input_container>
                                </Th>
                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <DatePicker
                                            selected={download_at}
                                            onChange={(date) => {
                                                this.setState({
                                                    download_at: date,
                                                });
                                            }}
                                            label="Téléchargé le"
                                            id="download_at_id"
                                        />
                                    </Search_input_container>
                                </Th>
                                <Th backgroundColor="#fff">
                                    <Search_input_container>
                                        <SearchSelect
                                            fetchedUrl="/api/utilisateurs"
                                            HTTPMethod="post"
                                            receivedObject="utilisateurs"
                                            optionLabelProperty="fullname"
                                            optionValueProperty="id"
                                            value={this.state.selected_user}
                                            placeholder="Téléchargé par"
                                            onChange={(e) => {
                                                this.setState({ selected_user: e, user_id: e.value });
                                            }}
                                        />
                                    </Search_input_container>
                                </Th>

                                <Th backgroundColor="#fff"></Th>
                            </tr> */}
                            {(search || advancedSearch) && (
                                <tr className="table_th_orderable">
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <CustomInput
                                                onKeyDown={this.handleKeyDown.bind(this)}
                                                onChange={(value) => {
                                                    this.setState({ name: value.target.value });
                                                }}
                                                label="Nom"
                                                value={name}
                                                defaultValue={name}
                                            ></CustomInput>
                                            <Search_icon>
                                                <Svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                    <path
                                                        fill="currentColor"
                                                        d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                    ></path>
                                                </Svg>
                                            </Search_icon>
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <DatePicker
                                                selected={date}
                                                onChange={(date) => {
                                                    this.setState({
                                                        date: date,
                                                    });
                                                }}
                                                label="Date"
                                                id="date"
                                                dateFormat="yyyy-MM-dd"
                                                showTimeSelect={false}
                                            />
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <SearchSelect
                                                fetchedUrl="/api/comptes"
                                                HTTPMethod="post"
                                                receivedObject="comptes"
                                                optionLabelProperty="libelle"
                                                optionValueProperty="id"
                                                value={this.state.selected_account}
                                                placeholder="Compte"
                                                onChange={(e) => {
                                                    this.setState({ selected_account: e, account_id: e && e.value });
                                                }}
                                            />
                                        </Search_input_container>
                                    </Th>

                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <SearchSelect
                                                fetchedUrl="/api/produits"
                                                HTTPMethod="get"
                                                receivedObject="ressources"
                                                optionLabelProperty="nom"
                                                optionValueProperty="id"
                                                value={this.state.selected_product}
                                                placeholder="Produit"
                                                onChange={(e) => {
                                                    this.setState({ selected_product: e, product_id: e && e.value });
                                                }}
                                            />
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <DatePicker
                                                selected={download_at}
                                                onChange={(date) => {
                                                    this.setState({
                                                        download_at: date,
                                                    });
                                                }}
                                                label="Téléchargé le"
                                                id="download_at_id"
                                                dateFormat="yyyy-MM-dd"
                                                showTimeSelect={false}
                                            />
                                        </Search_input_container>
                                    </Th>
                                    <Th backgroundColor="#fff">
                                        <Search_input_container>
                                            <SearchSelect
                                                fetchedUrl="/api/utilisateurs"
                                                HTTPMethod="post"
                                                receivedObject="utilisateurs"
                                                optionLabelProperty="fullname"
                                                optionValueProperty="id"
                                                value={this.state.selected_user}
                                                placeholder="Téléchargé par"
                                                onChange={(e) => {
                                                    this.setState({ selected_user: e, user_id: e && e.value });
                                                }}
                                            />
                                        </Search_input_container>
                                    </Th>

                                    <Th backgroundColor="#fff">
                                        <Search_btn onClick={() => this.setState({ pageNumber: 1, is_loaded: false }, () => this.getAll())}>
                                            <Search_btn_icon aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" className="svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                                <path
                                                    fill="#fff"
                                                    d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
                                                ></path>
                                            </Search_btn_icon>
                                        </Search_btn>
                                    </Th>
                                </tr>
                            )}
                            <tr className="table_th_orderable">
                                <Th key="nom" orderBy={key === "nom" && orderBy} onClick={() => this.setState({ key: "nom", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "nom" && orderBy === -1) || orderBy === 0 || key !== "nom") && <OrderUp />}
                                    {((key === "nom" && orderBy === 1) || orderBy === 0 || key !== "nom") && <OrderDown />}
                                    Nom
                                </Th>
                                <Th key="date" orderBy={key === "date" && orderBy} onClick={() => this.setState({ key: "date", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "date" && orderBy === -1) || orderBy === 0 || key !== "date") && <OrderUp />}
                                    {((key === "date" && orderBy === 1) || orderBy === 0 || key !== "date") && <OrderDown />}
                                    Date
                                </Th>
                                <Th key="compte" orderBy={key === "compte" && orderBy} onClick={() => this.setState({ key: "compte", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "compte" && orderBy === -1) || orderBy === 0 || key !== "compte") && <OrderUp />}
                                    {((key === "compte" && orderBy === 1) || orderBy === 0 || key !== "compte") && <OrderDown />}
                                    Compte
                                </Th>
                                <Th key="produit" orderBy={key === "produit" && orderBy} onClick={() => this.setState({ key: "produit", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "produit" && orderBy === -1) || orderBy === 0 || key !== "produit") && <OrderUp />}
                                    {((key === "produit" && orderBy === 1) || orderBy === 0 || key !== "produit") && <OrderDown />}
                                    Produit
                                </Th>
                                <Th key="cree_le" orderBy={key === "cree_le" && orderBy} onClick={() => this.setState({ key: "cree_le", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "cree_le" && orderBy === -1) || orderBy === 0 || key !== "cree_le") && <OrderUp />}
                                    {((key === "cree_le" && orderBy === 1) || orderBy === 0 || key !== "cree_le") && <OrderDown />}
                                    Téléchargé le
                                </Th>
                                <Th key="telecharge_par" orderBy={key === "telecharge_par" && orderBy} onClick={() => this.setState({ key: "telecharge_par", orderBy: this.getOrderBy() }, () => this.getAll())}>
                                    {((key === "telecharge_par" && orderBy === -1) || orderBy === 0 || key !== "telecharge_par") && <OrderUp />}
                                    {((key === "telecharge_par" && orderBy === 1) || orderBy === 0 || key !== "telecharge_par") && <OrderDown />}
                                    Téléchargé par
                                </Th>

                                <Th className="table_actions" />
                            </tr>
                        </thead>

                        {!is_loaded && (
                            <tbody>
                                {[1, 2, 3].map((index) => {
                                    return (
                                        <Tr key={"key__" + index}>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td>
                                                <ContentLoader width="160" height="20">
                                                    <rect x="0" y="0" rx="3" ry="3" width="160" height="20" />
                                                </ContentLoader>
                                            </Td>
                                            <Td className="table_action">
                                                <a className="sprite-table-edit-btn  tooltip" title="Modifier" data-confirm_msg data-removeable_element="parents::tr" target="_blank" />
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </tbody>
                        )}

                        {is_loaded && data && data.photos.length != 0 && (
                            <tbody>
                                {data &&
                                    data.photos.map((photo, index) => {
                                        return (
                                            <Tr key={"key_" + index}>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {photo.nom}
                                                </Td>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {moment(photo.date).format("YYYY-MM-DD HH:mm")}
                                                </Td>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {photo.compte}
                                                </Td>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {photo.produit}
                                                </Td>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {moment(photo.cree_le).format("YYYY-MM-DD HH:mm")}
                                                </Td>
                                                <Td
                                                    onClick={() => {
                                                        acl.gallery.details() && this.props.history.push(`${RoutesPath.gallery.details}/${photo.id}`);
                                                    }}
                                                >
                                                    {photo.telecharge_par}
                                                </Td>

                                                <Td className="table_action">
                                                    {disabledData === 0 && acl.gallery.update() && (
                                                        <a
                                                            onClick={() => {
                                                                this.props.history.push(`${RoutesPath.gallery.update}/${photo.id}`);
                                                            }}
                                                            className="sprite-table-edit-btn  tooltip"
                                                            title="Modifier"
                                                            data-confirm_msg
                                                            data-removeable_element="parents::tr"
                                                            target="_blank"
                                                        />
                                                    )}
                                                    {disabledData === 0 && acl.gallery.disable() && <a onClick={() => this.delete(photo.id)} className="sprite-table-delete-btn  tooltip" title="Archiver" data-confirm_msg data-removeable_element="parents::tr" target="_blank" />}
                                                    {disabledData === 1 && acl.gallery.restore() && <a onClick={() => this.restore(photo.id)} className="sprite-table-recover-btn restore_delivery_note tooltip" title="Restaurer" data-confirm_msg="" data-removeable_element="parents::tr"></a>}
                                                </Td>
                                            </Tr>
                                        );
                                    })}

                                <Tr>
                                    <Td colSpan={8} className="table_pagination">
                                        <div style={{ display: "inline-block", marginRight: "20px" }}></div>
                                        <div style={{ display: "inline-block" }}>
                                            {pageNumber > 1 && (
                                                <a
                                                    className="sprite-table-prev-btn"
                                                    onClick={() => {
                                                        this.setState({ pageNumber: pageNumber - 1 }, () => {
                                                            this.getAll();
                                                        });
                                                    }}
                                                />
                                            )}
                                            <span className="table_page">{pageNumber}</span>
                                            {pageNumber < totalItems / 20 && (
                                                <a
                                                    className="sprite-table-next-btn"
                                                    onClick={() => {
                                                        this.setState({ pageNumber: pageNumber + 1 }, () => {
                                                            this.getAll();
                                                        });
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </Td>
                                </Tr>
                            </tbody>
                        )}
                    </table>
                </div>
                {is_loaded && error.is && <DataLoadingError message={error.message} />}

                {is_loaded && data && data.photos.length == 0 && <NoResultCas btnOnClick={() => acl.gallery.add() && this.props.history.push(RoutesPath.gallery.add)} btnText={acl.gallery.add() && "Ajouter une photo"} textInfos="Vous n’avez aucune photo pour le moment"></NoResultCas>}
            </Bloc>
        );
    }
}

const Th = styled.th`
    cursor: pointer;
    background: ${(props) => props.backgroundColor} !important;
    border-style: solid;
    border-color: #28b9ac;
    border-bottom-width: ${(props) => (props.orderBy === 1 ? "1px" : 0)};
    border-top-width: ${(props) => (props.orderBy === -1 ? "1px" : 0)};
`;
const Td = styled.td`
    border-top: 1px solid #8d8d8d;
    wordwrap: "break-word";
    font-weight: 600;
    padding: 6px 5px;
`;
const Tr = styled.tr`
    cursor: pointer;
`;
const Tag_no = styled.strong`
    padding: 3px 10px 3px 10px;
    border-radius: 3px;
    background-color: #db544c;
    color: #fff;
    display: inline-block;
`;
const Tag_yes = styled.strong`
    padding: 3px 12px 3px 12px;
    border-radius: 3px;
    background-color: #28b9ac;
    color: #fff;
    display: inline-block;
`;
const OrderUp = styled.a`
    background-image: url(${img});
    background-repeat: no-repeat;
    display: inline-block;
    width: 6px;
    height: 4px;
    ${"" /* width: 100px;
    height: 100px; */}
    background-position: -213px -98px;
    position: absolute;
    right: 6px;
    top: 50%;
    margin-top: -4px;
`;
const OrderDown = styled.a`
    background-image: url(${img});
    background-repeat: no-repeat;
    display: inline-block;
    width: 8px;
    height: 5px;
    background-position: -195px -98px;
    position: absolute;
    right: 5px;
    top: 50%;
    margin-top: 4px;
`;

const Search_input_container = styled.div`
    height: 38px;
    position: relative;
`;
const Search_icon = styled.div`
    position: absolute;
    height: 10px;
    width: 10px;
    top: 10px;
    right: 10px;
`;
const Svg = styled.svg`
    width: 15px;
`;
const SearchTr = styled.tr`
    background: "#fff";
`;
const Search_btn = styled.button`
    width: 28px;
    height: 27px;
    outline: none;
    border: 0;
    background: #00beb0;
    position: relative;
    cursor: pointer;
    padding-top: 5px;
    border-radius: 3px;
`;
const Search_btn_icon = styled.svg`
    width: 15px;
`;
const Bloc = styled.div`
    box-shadow: 0 1px 3px 0 #bcbcbc;
    width: 96.3%;
    position: relative;
    margin: auto;
    margin-bottom: 60px;
    margin-top: 10px;
`;
export default GalleryTable;
